export default __webpack_public_path__ + "static/media/tick.83114401.svg";